import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form,Popover, Spin, Select, Space } from 'antd';
import { HomeOutlined, SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import './academicStaffReport.css'

const { Option } = Select;

const student = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [studentModel, setStudentModel] = useState({});
    const [studentProgModel, setStudentProgModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [studentProgList, setStudentProgList] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    const [deleteFlag, setDeleteFlag] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [deptModel, setDeptModel] = useState([]);

    const tableColumns = {
        academicStaffAcctId: "academicStaffAcctId",
        staffName:"staffName",
        staffSaluation: "staffSaluation",
        departmentName:"departmentName",
        roleName: "roleName",
        programmeCode:"programmeCode",
        programmeName: "programmeName",
        wpaStandApproveInd:"wpaStandApproveInd",
        jobappStandApproveInd: "jobappStandApproveInd",
        receiveNotiInd:"receiveNotiInd",
        activeInd: "activeInd",
        inactiveDate:"inactiveDate",
        baseProgTitle:"baseProgTitle",
        baseProgDept:"baseProgDept",
    }
    useEffect(() => {
        search(pageSize, 1, "N");
        searchDept();
    }, []);

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }
    const searchDept  = ()  =>{ 
        Base.callBackApi('commonDropDown/searchAllDept').then((data) => {
            if ("SUCCESS" == data.msg) {
                setDeptModel(data?.object?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("academicStaff/getExportList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    //添加
    const add = () => {
        messageShowHandler();//清空提示信息
        setStudentModel({})
        setStudentProgList([])
        initForm({ activeInd: 'Y', dataPrivacyNoticeInd: 'Y' });
        setFlag("add");
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            studentAcctId: model.studentAcctId ?? '',
            studentName: model.studentName ?? '',
            email: model.email ?? '',
            birthMonth: (model.birthMonth && moment(model.birthMonth, Config.dateFormat6)) ?? '',
            activeInd: model.activeInd ?? '',
            inactiveDate: (model.inactiveDate && moment(model.inactiveDate)) ?? null,
            dataPrivacyNoticeInd: model.dataPrivacyNoticeInd ?? '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    //删除
    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        if (deleteFlag === 'studentProg') {
            let model = studentProgModel;
            model.menuFuncId = Config.funcInfo.funcId;
            Base.callBackApi("studentProgramme/delete", model).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchStudentProgList(studentModel);
                    errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(
                () => {
                    setIsLoad(false)
                    setDeleteFlag('')
                }
            );
        } else {
            let model = studentModel;
            model.menuFuncId = Config.funcInfo.funcId;
            Base.callBackApi("student/delete", model).then((data) => {
                if ("SUCCESS" === data.msg) {
                    setSearchModel({});
                    search(pageSize, current, "Y", false);
                    errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    const uploadClose = (flag) => {
        // if (flag) {
        //     if (!(Config.userInfo.role.roleCode === "SYS_ADMIN" || Config.userInfo.role.roleCode === "ADMIN") || searchModel.customerMgtId) {
        //         search(pageSize, 1, "N");
        //     }
        //     errFrameShow("success", trans.importSuccess[Config.backLang]);
        // }
        setIsUpload(false);
    }

    //取消 
    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const searchById = (studentId) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("student/searchById", studentId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setFlag("edit");
                initForm(model)
                setStudentModel(model)
                searchStudentProgList(model);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    /**查询Student的StudentProglist */
    const searchStudentProgList = (model) => {
        Base.callBackApi("studentProgramme/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setStudentProgList(data.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => { });
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "Academic Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "academicStaff/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }


    /*eslint-disable*/
    const columns = [
        {
            title: 'Academic User ID',
            dataIndex: 'userId',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userId') },
        },
        {
            title: 'CNA',
            dataIndex: 'academicStaffAcctId',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'academicStaffAcctId') },
        },
        {
            title: 'Academic Name',
            dataIndex: 'staffName',
            className: 'tableWidth6',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'staffName') },
            render: (text, record) => record.firstName + ' ' + record.lastName
        },
        {
            title: "Saluation",
            dataIndex: 'staffSaluation',
            className: 'tableWidth4',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'staffSaluation') },
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth5',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth4',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'activeInd') },
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth6',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
            render: (text) => text!=null?moment(text).format(Config.dateFormat5):null
        },
        {
            title: "Base Programme",
            dataIndex: 'baseProgTitle',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'baseProgTitle') },
            render:(text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        {
            title: "Base Department",
            dataIndex: 'baseProgDept',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'baseProgDept') },
            render:(text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        {
            title: "WPA Standing Approval",
            dataIndex: 'wpaStandApproveInd',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wpaStandApproveInd') },
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: "JobApp Standing Approval",
            dataIndex: 'jobappStandApproveInd',
            className: 'tableWidth9',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobappStandApproveInd') },
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: "Receive Notification ",
            dataIndex: 'receiveNotiInd',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'receiveNotiInd') },
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: "Role Name",
            dataIndex: 'roleName',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'roleName') },
        },
        {
            title: "Role Programme Name",
            dataIndex: 'programmeName',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'programmeName') },
            render:(text) => <Popover content={text} title="" trigger="hover">
                <div>{text}</div>
            </Popover>
        },
        {
            title: "Role Department",
            dataIndex: 'departmentName',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'departmentName') },
            render: (text,value) => <Popover content={text && value.departmentCode +"-" +text} title="" trigger="hover">
                <div>{text && value.departmentCode +"-" +text}</div>
            </Popover>
        },
    ];

    const submit = () => {
        search(pageSize, 1, "N", true);
    }
    const checkStartDate = (rule, value) => {
        if (Base.isNotEmpty(searchModel.endDate) && Base.afterDate(value, searchModel.endDate)) {
            return Promise.reject("To Date cannot be earlier than From Date.")
        }
        return Promise.resolve();
    }
    const checkEndDate = (rule, value) => {
        if (Base.isNotEmpty(searchModel.startDate) && Base.afterDate(searchModel.startDate, value)) {
            return Promise.reject("From Date cannot be later than To Date.")
        }
        return Promise.resolve();
    }

    /*eslint-enable*/

    return (
        <div id="container" className="template academicStaffReport">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.admin[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Form form={form} onFinish={submit}>
                        <div className='sysSearchRow sysSearchBox'>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">{trans.academicStaffId[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.academicStaffAcctId || ''} maxLength={200}
                                            placeholder={trans.academicStaffId[Config.backLang]}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('academicStaffAcctId', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">{trans.academicStaffName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.staffName || ''} maxLength={200}
                                            placeholder={trans.academicStaffName[Config.backLang]}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('staffName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Role Name</div>
                                    <div className="sysSerchInput ">
                                        <Input type="text" value={searchModel.roleName || ''}  maxLength={200}
                                            placeholder="Role Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('roleName', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Department</div>
                                    <div className="sysSerchInput">
                                    
                                        <Select className='sysSelect' placeholder="Department" value={searchModel.departmentName } maxLength={200}
                                            onChange={(e) => searchChange('departmentName', e)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                        >

                                            <Option value=''></Option>
                                            {deptModel.map((item) => <Option key={item.deptCode} value={item.deptCode}>{item.deptCode + "-" + item.deptDisplayName}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Programme Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.programmeName || ''} maxLength={150}
                                            placeholder="Programme Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('programmeName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">{trans.activeInd[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select className="sysSelect" placeholder={trans.activeInd[Config.backLang]}
                                            value={searchModel.activeInd}
                                            onChange={(e) => searchChange('activeInd', e)}
                                        >
                                            <Option value=""></Option>
                                            {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" htmlType="submit" hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="sysLineEight"></div>
                    <Space size={[5, 5]} wrap className="sysButtonRelative">
                    {tables.length == 0 ? null :
                        <>
                        <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>Export</Button>
                        </>
                    }
                    </Space>
                    <div className="sysTable" id="tableOne">
                        <Table
                            scroll={{ x: 2500 }}
                            rowKey="index"
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,             //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,                               //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>

                </Spin>
            </div>

        </div>
    )
}

export default student;